import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    getAccessToken,
    trackBusinessError,
} from '@sxm-de/dev-kits/web-sdk/utils';

interface UpdateEmailAddressFnPayload {
    newEmailHandle: string;
    // TODO: remove this and get identity id from authenticated user within here
    identityId: string;
}

export type UpdateEmailAddressFn = (
    payload: UpdateEmailAddressFnPayload,
) => Promise<void>;

export function initUpdateEmailAddressFn({
    dependencies,
}: DomainInitPayload): UpdateEmailAddressFn {
    const { appEventSdk, atlasSdk } = dependencies;
    return async ({
        newEmailHandle,
        identityId,
    }: UpdateEmailAddressFnPayload) => {
        try {
            await atlasSdk.domains.user.updateEmailAddress({
                request: {
                    newEmailHandle,
                    targetIdentityId: identityId,
                },
                accessToken: getAccessToken(),
            });
            /**
             * TODO:
             * Do we need to do anything else here to refresh the AUTH_TOKEN?
             */
        } catch (error: any) {
            if (
                (error as { code: string })?.code ===
                'userServices.identityGroup.handleAlreadyInUse'
            ) {
                trackBusinessError(appEventSdk, error);
                throw new Error('HANDLE_ALREADY_IN_USE');
            }
            if (
                (error as { code: string })?.code ===
                'userServices.identityGroup.invalidEmail'
            ) {
                trackBusinessError(appEventSdk, error);
                throw new Error('EMAIL_INVALID');
            }
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
